import { render, staticRenderFns } from "./bulk-assign.vue?vue&type=template&id=0b1a4daf&"
import script from "./bulk-assign.vue?vue&type=script&lang=js&"
export * from "./bulk-assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports